














































































import Vue from 'vue'
const vueJsonEditor = require('vue-json-editor').default
export default Vue.extend({
  name: 'JSONViewerDialogTabs',
  props: {
    value: Object,
    show: Boolean,
  },
  components: {
    vueJsonEditor,
  },
  data() {
    return {
      visible: false,
      jsonData: '',
      // eslint-disable-next-line
      dataToBeSent: {} as any,
      dataActual: {},
      tableFields: [] as string[],
    }
  },
  watch: {
    show: function(val) {
      this.visible = val
    },
    visible: function(val) {
      this.$emit('update:show', val)
    },
    // eslint-disable-next-line
    value: function(val: any) {
      this.jsonData = JSON.stringify(val.toSubmit)
      this.dataToBeSent = val.toSubmit
      this.dataActual = val.actual

      if (Array.isArray(this.dataToBeSent.parameter)) {
        const row = this.dataToBeSent.parameter[0]
        this.tableFields = ['waktu']
        for (const key in row) {
          if (key == 'waktu') {
            continue
          }
          this.tableFields.push(key)
        }
      }
    },
  },

  methods: {
    copyToClipboard() {
      /* Get the text field */
      // eslint-disable-next-line
      const copyText: any = document.getElementById('json-input')
      copyText.type = 'text'

      /* Select the text field */
      copyText.select()
      copyText.setSelectionRange(0, 99999) /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand('copy')
      copyText.type = 'hidden'
    },
  },

  created() {
    this.jsonData = JSON.stringify(this.value)
  },
})
